export const buttonGroupTheme = {
  root: {
    borderRadius: 20,
  },
}
